import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";
import axios from "axios";
import missionGem from "../../assets/images/mission-gem-gray.3e5c033.png";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import getfile from "../../utils/getFile";
import LoadingBar from "../LoadingBar";
import { useLiffProfile } from "../../context/LiffProfileContext";
import MissionsCard from "./missionsCard";
import TermsAndConditions from "./termsAndConditions";

const MissionsCateDetail = () => {
  const { t, i18n } = useTranslation();
  const { authToken, userId } = useLiffProfile();
  const { id } = useParams();
  const [missionData, setMissionData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState("duration");
  const [category, setCategory] = useState("");
  const [imageUrls, setImageUrls] = useState({});
  const navigate = useNavigate();
  const [longDescription, setLongDescription] = useState("");

  useEffect(() => {
    setLoading(true);

    const apiUrl = `${process.env.REACT_APP_API_URL}/api/clm-missions/`;
    const clientAuth = process.env.REACT_APP_CLIENT_AUTH;

    axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "X-Client-Auth": clientAuth,
          "x-user-id": userId,
          "Accept-Language": i18n.language.toUpperCase(),
        },
      })
      .then((response) => {
        if (response.data && response.data.data) {
          const filteredData = response.data.data.items.filter(
            (item) => item.category === id
          );
          setMissionData(filteredData);
          if (filteredData.length > 0) {
            setCategory(filteredData[0].categoryName || "");
          }
          //console.log("Fetching data detail:", response.data.data);

          // Fetch images using the updated imagePromises code
          const imagePromises = filteredData.map((item) => {
            if (item.image) {
              return getfile(item.image, authToken, userId).then((url) => ({
                id: item.id,
                url,
              }));
            }
            return Promise.resolve(null);
          });

          Promise.all(imagePromises).then((results) => {
            const imageMap = {};
            results.forEach((result) => {
              if (result) {
                imageMap[result.id] = result.url;
              }
            });
            setImageUrls(imageMap);
          });
        } else {
          setError("No data found for this category.");
        }
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    if (!missionData.length) return; // ยังไม่มีข้อมูล ไม่ต้อง fetch

    const latestMission = missionData[missionData.length - 1];
    if (!latestMission?.id) return; // ป้องกัน error เผื่อไม่มี id

    const fetchLongDescription = async () => {
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/clm-missions/${latestMission.id}`;

      const clientAuth = process.env.REACT_APP_CLIENT_AUTH;
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "X-Client-Auth": clientAuth,
            "x-user-id": userId,
            "Accept-Language": i18n.language.toUpperCase(),
          },
        });

        if (response.data && response.data.data) {
          setLongDescription(response.data.data.longDescription || "");
        }
      } catch (err) {
        console.error("Failed to fetch longDescription", err);
      }
    };

    fetchLongDescription();
  }, [missionData]);

  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <LoadingBar loading={true} label="Loading..." />
      </div>
    );
  }

  if (error) return <p className="text-center text-red-500">{error}</p>;

  // console.log(missionData);
  const latestMission =
    missionData.length > 0 ? missionData[missionData.length - 1] : null;

  return (
    <div className="w-full flex flex-col gap-y-4 px-2">
      <div className="h-screen flex flex-col bg-secondary-background">
        <ProfileWithBackButtonHeader className="bg-primary" />
        <div className="w-full flex flex-col px-2 py-2 bg-secondary-background bg-primary">
          <h2 className="text-3xl pt-3 pb-3 font-bold">
            {t("big_c_mission_detail")}
          </h2>
        </div>
        <div className="flex-grow overflow-y-auto p-4">
          {/* <div className="text-xl font-semibold mb-4">
            {category ? `หมวดหมู่: ${category}` : "ไม่มีหมวดหมู่"}
          </div> */}
          {missionData.length > 0 ? (
            <>
              {latestMission && (
                <MissionsCard
                  item={latestMission}
                  missionsInCategory={missionData}
                  imageUrls={imageUrls}
                  isExpiredMission={
                    (latestMission.dayToExpire ?? -1) < 0 ||
                    latestMission.status === "E"
                  }
                  templateDetail={true}
                  actionLink={`#`}
                  showDescription={false}
                />
              )}

              <div className="w-full h-13 relative flex bg-overlay-5 rounded-full font-medium p-1 cursor-pointer text-lg sm:text-base">
                <div
                  className="h-[calc(100%-0.5rem)] absolute rounded-full bg-primary z-0 duration-300 ease-out"
                  style={{
                    width: "calc(50% - 0.25rem)",
                    transform: `translateX(${
                      selectedTab === "duration" ? "0%" : "100%"
                    })`,
                  }}
                />
                <div className="flex-1 h-full flex justify-center items-center rounded-full z-10 pt-2 pb-2">
                  <button
                    onClick={() => setSelectedTab("duration")}
                    className={`text-lg font-semibold ${
                      selectedTab === "duration" ? "" : "text-black"
                    }`}
                  >
                    {t("all")}
                  </button>
                </div>
                <div className="flex-1 h-full flex justify-center items-center rounded-full z-10 pt-2 pb-2">
                  <button
                    onClick={() => setSelectedTab("terms")}
                    className={`text-lg font-semibold ${
                      selectedTab === "terms" ? "" : "text-black"
                    }`}
                  >
                    {t("terms_and_conditions")}
                  </button>
                </div>
              </div>

              {selectedTab === "duration" &&
                (() => {
                  const sortedMissionData = [...missionData].sort(
                    (a, b) => a.isCompleted - b.isCompleted
                  );

                  return (
                    <div>
                      {sortedMissionData.map((item) => {
                        const isExpiredMission =
                          (item.dayToExpire ?? -1) < 0 || item.status === "E";

                        return (
                          <MissionsCard
                            key={item.id}
                            item={item}
                            missionsInCategory={[item]}
                            imageUrls={imageUrls}
                            isExpiredMission={isExpiredMission}
                            templateDetail={false}
                            actionLink={`/missions/detail/${item.id}`}
                            showDescription={false}
                          />
                        );
                      })}
                    </div>
                  );
                })()}

              {selectedTab === "terms" && (
                <TermsAndConditions
                  latestMission={latestMission}
                  longDescription={longDescription}
                />
              )}
            </>
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center">
              <img
                src={require("../../assets/images/mission-biggy-bear.0da057a.png")}
                alt="No Missions"
                className="w-40 mt-10"
              />
              <div className="mt-5 text-center">
                <span className="font-semibold text-22">
                  {t("mission_empty_header")}
                </span>
                <br />
                <span className="font-normal">{t("mission_empty_desc")}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MissionsCateDetail;
